module.exports = __webpack_public_path__ + "static/mini-logo-c259650915adead914309c5ac0309b16.png";